import React, {
    useState,
    Suspense,
    lazy
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
} from '@mantine/core';
import {
    DatePicker,
    TimeInput
} from '@mantine/dates';
import {
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import {
    calculateWorkload
} from '../api/FileWorker';
import { 
    fieldInfoUpdated,
    selectSectionData,
    testLogin,
    testUpload,
    selectImage,
    fetchTests,
    testPost,
    testLogout
} from '../features/home/homeSlice';

//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));
//needed:move below methods to opcodeMGMT so they can be used as tools




const convertBlob =  url =>{
    let reader = new FileReader();
    console.log(reader)
    reader.readAsDataURL(url);
    
    reader.onloaded = () => {
        let base64String = reader.result;
        console.log('Base64 String - ', base64String);
      
        // Simply Print the Base64 Encoded String,
        // without additional data: Attributes.
        console.log('Base64 String without Tags- ', 
            base64String.substr(base64String.indexOf(', ') + 1));
    }
    return reader.result;
    //return blob;
}
async function convertBlobOb(url) {
    //await fetch(url).then(r => r.blob())
    //let blob = await fetch(url).then(r => r.blob());
    let response = await fetch(url);
    let res = await response.blob();//.then(r => r.blob());
    return res;
    
}
function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
    });
}
const testerData = {
    dataFieldA: "|",
    dataFieldB: 69,
    dataFieldC: "more_INFO HERE",
}

//needed:dummy data for when nothing is filled out and grabbing data from the carCreator Section
export function CarCreationCardA() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    
    //of_note: 'item' is normally included here
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'detailsSection_6',
    }
    
    const [sectionOpen, setSectionOpened] = useState(false);
    
    const [listingAudience, setListingAudience] = useState('public');
    const images = useSelector(selectImage);
    //console.log(`length of images: ${images.length}`);
    const [loadedFiles, setLoadedFiles] = useState([]);
    let ablob = null;
    //const testAPIClicked = (e) => {
    //use for reference of many items
    const testAPIClicked = async () => {
        console.log('clicked tester');
        let a = await dispatch(fetchTests());//descript:get test files uploaded
        unwrapResult(a);
        console.log(a);
        //testing a post method as well
        
        let postPayload = JSON.stringify(testerData);
        
        let b = await dispatch(testPost(postPayload));
        unwrapResult(b);
        console.log(b);

        console.log('creating promise contain')
        localStorage.setItem("a-token", "token-storage-information");
        console.log(`value we set in local storage ${localStorage.getItem('a-token')}`)
        //let tempForm = new FormData();
        /*let tempForm = new URLSearchParams();
        tempForm.append("username", "ggagen@ready.auction");
        tempForm.append("password", "f4tK4t$");
        let c = await dispatch(testLogin(tempForm))
        //unwrapResult(c);
        console.log(c);*/
        
        
        //logout, refresh, file -> byte-array_buffer-> upload file functionality
        
        
        let promisesContain = [];
        for(let i = 0; i < 1; i++){
            console.log('creating a promise');
            
            //descript:one fetch statement
            let srcData = fetch(images[i]['src'])
                .then(r => r.blob())//working
                /*.then((r) => {
                    console.log(r.blob.size)
                    r.blob()
                    
                })*/
                //.then(data => blobToBase64(data))
                //repeat the same and append it to 
                .then((data) => {
                    //workingi with blob @ this point
                    console.log(data.size);
                    console.log(`total cores: ${navigator.hardwareConcurrency}`);
                    calculateWorkload(data.size, images[i]['origName'])
                    return blobToBase64(data)
                })
                .then((b64Data) => {
                    let upldOb = {
                        listingId: nanoid(),
                        src: b64Data,
                        title: `my_cool_car_${nanoid()}`,
                        mime: 'image/png'
                    };
                    let upldPayload = JSON.stringify(upldOb);
                    
                    return upldPayload;
                })
                .then(payload => dispatch(testUpload(payload)).unwrap())
                .catch((err) => {
                    console.log(`error occurred while creating promise\n ${err}`)
                });
            console.log('finished');
            promisesContain.push(srcData);
        }
        //descript:wrapping promise contain up
        Promise.all(promisesContain).then((res) => {
            console.log(`successful result:\n\n\n ${res}`);
        })
        .catch((err) => {
            console.log(`error in promise all\n\n ${err}`);
        })
        
        
        
        /*let d = await dispatch(testLogout(postPayload));
        unwrapResult(d);
        console.log(d);*/
        
    }
    
    //const n_title = useSelector(carCreatorSelectSectionData)
    //const n_title = useSelector(carCreatorSelectSectionDataB(activeSection, 'listingTitle'))
    const n_Title = useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'listing_title_0'
            }
        )
    )
    //what will be used throughout for the selector
    
    //descript:gather info from redux as needed and map for form items in the carCreationCardA
    const rdux_map = {
        listing_title_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'listing_title_0'
            }
        )),
        car_make_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'car_make_0'
            }
        )),
        model_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'model_0'
            }
        )),
        yr_1: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'yr_1'
            }
        )),
        transmission_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'transmission_0'
            }
        )),
        engine_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'engine_0'
            }
        )),
        mileage_1: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'mileage_1'
            }
        )),
        start_price_1: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'start_price_1'
            }
        )),
        has_reserve_5: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'has_reserve_5'
            }
        )),
        res_disabled_5: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'res_disabled_5'
            }
        )),
        reserve_amt_1: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'reserve_amt_1'
            }
        )),
        auction_date_range_2_4: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'auction_date_range_2_4'
            }
        )),
        start_time_4: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'start_time_4'
            }
        )),
        end_time_4: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'end_time_4'
            }
        )),
        state_loc_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'state_loc_0'
            }
        )),
        city_loc_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'city_loc_0'
            }
        )),
        vin_0: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'vin_0'
            }
        )),
    }
    
    
    
    //works with stream line
    //leave for now... improvements can be made
    //needed: exterior and interior colors
    const [title, setTitle] = useState(rdux_map['listing_title_0']);
    const [carMake, setCarMake] = useState(rdux_map['car_make_0']);
    const [carModel, setCarModel] = useState(rdux_map['model_0']);
    const [year, setYr] = useState(rdux_map['yr_1']);
    const [transmission, setTransmission] = useState(rdux_map['transmission_0']);
    const [vin, setVin] = useState(rdux_map['vin_0']);
    const [engine, setEngine] = useState(rdux_map['engine_0']);
    const [mileage, setMileage] = useState(rdux_map['mileage_1']);
    const [priceStart, setPriceStart] = useState(rdux_map['start_price_1']);
    const [hasReserve, setHasReserve] = useState(rdux_map['has_reserve_5']);
    const [reserveDisabled, setReserveDisabled] = useState(rdux_map['res_disabled_5']);
    const [reserveAmt, setReserveAmt] = useState(rdux_map['reserve_amt_1']);
    const [listingDateRange, setListingDateRange] = useState(rdux_map['auction_date_range_2_4']);
    const [startTime, setStartTime] = useState(rdux_map['start_time_4']);
    const [endTime, setEndTime] = useState(rdux_map['end_time_4']);
    const [stateLoc, setStateLoc] = useState(rdux_map['state_loc_0']);
    const [cityLoc, setCityLoc] = useState(rdux_map['city_loc_0']);
    

    
    //descript:assign value to compoent state and dispatch redux slice
    const handleItemChange = (name, e) => {
        let res = true;
        let value = e;
        switch(name){
            case 'listing_title_0':
                setTitle(e.target.value);
                value = e.target.value;
                break;
            case 'car_make_0':
                setCarMake(e);
                break;
            case 'model_0':
                setCarModel(e);
                break;
            case 'yr_1':
                setYr(e);
                break;
            case 'transmission_0':
                setTransmission(e);
                break;
            case 'engine_0':
                setEngine(e.target.value);
                value = e.target.value;
                break;
            case 'mileage_1':
                setMileage(e);
                break;
            case 'start_price_1':
                setPriceStart(e);
                break;
            case 'has_reserve_5':
                setHasReserve(e.target.value);
                value = e.target.value;
                break;
            case 'res_disabled_5':
                setReserveDisabled(e);
                break;
            case 'reserve_amt_1':
                setReserveAmt(e);
                break;
            case 'auction_date_range_2_4':
                setListingDateRange(e);
                break;
            case 'auction_date_range_2_4':
                setListingDateRange(e);
                break;
            case 'start_time_4':
                setStartTime(e);
                break;
            case 'end_time_4':
                setEndTime(e);
                break;
            case 'state_loc_0':
                setStateLoc(e);
                break;
            case 'city_loc_0':
                setCityLoc(e);
                break;
            case 'vin_0':
                setVin(e.target.value);
                value = e.target.value;
                break;
            default:
                console.log(`name error\nissue with ${name}`)
                res = false
        }
        
        dispatch(fieldInfoUpdated(
            {
                itemVal: value,
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: name
            }
        ))
        return res;
    };
    
    //descript:used to set state and update  redux
    //of_note:this goes after all the 'useState' call
    //needed: figure out when opcode_mgmt interacts
    //needed: draw flow here
    const handleChangedEvent = (e, name, e_tpe) => {
        //needed:create switch on event_type
        //needed:create nested switch name of event_type
        switch(e_tpe){
            case 'onChange':
                handleItemChange(name, e);
                break;
            case 'onClick':
                console.log("have not planned this execution yet");
                break;
            default:
                console.log(`error occurred with e_tpe\nvalue: ${e_tpe}`);
        }
        
    }

    //needed: make catch all 'onChange' event handler and have a switch case on how that should be handled
    //needed:make a call to the db
    //needed:city and states in ref db
    //needed:custom image and card as the select model
    //needed:selectors after a status flag has been set that the data has been retrieved
    //needed:real ref calls
    const mockMakes = [
        { value: 'Audi', label: 'Audi' },
        { value: 'Buick', label: 'Buick' },
        { value: 'Bentley', label: 'Bentley' },
        { value: 'Chevrolet', label: 'Chevrolet' },
        { value: 'Datsun', label: 'Datsun' },
        { value: 'Fiskar', label: 'Fiskar' },
        { value: 'Ford', label: 'Ford' },
        { value: 'Pagani', label: 'Pagani' },
        { value: 'Porsche', label: 'Porsche' },
    ];
    const mockStates = [
        { value: 'Pennsylvania', label: 'Pennsylvania' },
        { value: 'California', label: 'California' },
        { value: 'Texas', label: 'Texas' },
        { value: 'Florida', label: 'Florida' },
        { value: 'New York', label: 'New York' },
        { value: 'Nevada', label: 'Nevada' },
        { value: 'Colorado', label: 'Colorado' },
        { value: 'New Mexico', label: 'New Mexico' },
        { value: 'Arizona', label: 'Arizona' },
    ];
    const mockCities = [
        { value: 'Pittsburgh', label: 'Pittsburgh' },
        { value: 'Los Angeles', label: 'Los Angeles' },
        { value: 'Houston', label: 'Houston' },
        { value: 'Miami', label: 'Miami' },
        { value: 'Manhattan', label: 'Manhattan' },
        { value: 'Nevada', label: 'Nevada' },
        { value: 'Denver', label: 'Denver' },
        { value: 'Alberquerque', label: 'Alberquerque' },
        { value: 'Phoenix', label: 'Phoenix' },
    ];
    const mockModels = [
        { value: 'R8', label: 'R8' },
        { value: 'Enclave', label: 'Enclave' },
        { value: 'Continental GT', label: 'Continental GT' },
        { value: 'Corvette', label: 'Corvette' },
        { value: '270z', label: '270z' },
        { value: 'Fiskar', label: 'Fiskar' },
        { value: 'Mustang', label: 'Mustang' },
        { value: 'Hauyra', label: 'Hauyra' },
        { value: '911 GT3', label: '911 GT3' },
    ];
    const mockTransmissions = [
        { value: 'Automatic', label: 'Automatic' },
        { value: 'Manual', label: 'Manual' },
        { value: 'Other', label: 'Other' },
    ];
    //needed: add body type drop-down
    const bodyTypes = [
        { value: 'Truck', label: 'Truck' },
        { value: 'Minivan', label: 'Minivan' },
        { value: 'Sedan', label: 'Sedan' },
        { value: 'Coupe', label: 'Coupe' },
    ];
    
    const arr = [];
    

    return (
        <>
            
            <br/>
            <Button onClick={testAPIClicked}>
            API TESTER
            </Button>
            <br/>
            <br/>
            <TextInput
                placeholder="Beautiful Mercedes SLR Mclaren 2009, Low Miles!!🏁"
                label="Listing Title"
                withAsterisk
                value={title}
                onChange={(e) => handleChangedEvent(e, "listing_title_0", "onChange")}
            />
            <Select
                label="Car Make"
                data={mockMakes}
                searchable
                withAsterisk
                clearable
                value={carMake}
                onChange={(e) => handleChangedEvent(e, "car_make_0", "onChange")}
            />
            <Select
                label="Car Model"
                data={mockModels}
                searchable
                withAsterisk
                clearable
                value={carModel}
                onChange={(e) => handleChangedEvent(e, "model_0", "onChange")}
            />
            <NumberInput
                label="Year"
                placeholder="Year"
                withAsterisk
                value={year}
                onChange={(e) => handleChangedEvent(e, "yr_1", "onChange")}
            />
            <Select 
                label="Transmission"
                data={mockTransmissions}
                clearable
                withAsterisk
                value={transmission}
                onChange={(e) => handleChangedEvent(e, "transmission_0", "onChange")}
            />
            <TextInput
                placeholder="4Y1SL65848Z411439"
                label="VIN"
                withAsterisk
                value={vin}
                onChange={(e) => handleChangedEvent(e, "vin_0", "onChange")}
            />
            <TextInput
                placeholder="5.4 L (5,439 cc) supercharged M155 SLR V8"
                label="Engine"
                withAsterisk
                value={engine}
                onChange={(e) => handleChangedEvent(e, "engine_0", "onChange")}
            />
            <NumberInput
                label="Mileage"
                placeholder="Mileage"
                withAsterisk
                value={mileage}
                onChange={(e) => handleChangedEvent(e, "mileage_1", "onChange")}
            />
            <br/>
            <br/>
            <NumberInput
                label="Starting Bid Price"
                placeholder="Starting Bid Price"
                withAsterisk
                value={priceStart}
                onChange={(e) => handleChangedEvent(e, "start_price_1", "onChange")}
            />
            <Switch
                checked={hasReserve}
                onChange={(e) => handleChangedEvent(e, "has_reserve_5", "onChange")}
                label="Has Reserve?"
            
            />
            <NumberInput
                label="Reserve Amt"
                placeholder="Reserve Amt"
                disabled={reserveDisabled}
                withAsterisk
                value={reserveAmt}
                onChange={(e) => handleChangedEvent(e, "reserve_amt_1", "onChange")}
            />
            <br/>
            <br/>
            <DatePicker
                label="Auction Date Range"
                placeholder="Pick date range"
                type="range"
                value={listingDateRange}
                onChange={(e) => handleChangedEvent(e, "auction_date_range_2_4", "onChange")}
            />
            <TimeInput
                label="Auction Start Time"
                value={startTime}
                onChange={(e) => handleChangedEvent(e, "start_time_4", "onChange")}
            />
            <TimeInput
                label="Auction End Time"
                value={endTime}
                onChange={(e) => handleChangedEvent(e, "end_time_4", "onChange")}
            />
            <Select
                label="State Location"
                data={mockStates}
                searchable
                clearable
                value={stateLoc}
                onChange={(e) => handleChangedEvent(e, "state_loc_0", "onChange")}
            />
            <Select 
                label="Car Location"
                data={mockCities}
                searchable
                clearable
                value={cityLoc}
                onChange={(e) => handleChangedEvent(e, "city_loc_0", "onChange")}
            />
             <SegmentedControl
                value={listingAudience}
                onChange={setListingAudience}
                data={[
                    { label: 'Public', value: 'Public' },
                    { label: 'Private', value: 'Private' },
                ]}
                defaultValue="Public"
                color="blue"
                transitionDuration={500}
                transitionTimingFunction="linear"
            />
            {/*needed: handle the user unexpectedly closing */}
            {/*needed: ensure the values are dispatched and save correctly
                review and addPost and editPost
                 */}
        </>
    );
    
}
